/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Deselectall2Inputs */

const en_datagrid_deselectall2 = /** @type {(inputs: Datagrid_Deselectall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deselect all`)
};

/**
* | output |
* | --- |
* | "Deselect all" |
*
* @param {Datagrid_Deselectall2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_deselectall2 = /** @type {((inputs?: Datagrid_Deselectall2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Deselectall2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_deselectall2(inputs)
});
export { datagrid_deselectall2 as "dataGrid_deselectAll" }